import React from "react";
import { useLang } from "../../i18n/LanguageContext";

const Mentor = () => {
  const { t } = useLang();
  const story = t("mentor.story");
  const values = t("mentor.values");
  return (
    <section id="mentor" className="relative py-32 lg:py-48 bg-[#081328] overflow-hidden" data-testid="mentor-section">
      {/* Gigantic motto behind */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <div className="serif italic text-white text-[18vw] leading-none opacity-[0.025] whitespace-nowrap">LOVE IS TRANSFORMATION</div>
      </div>

      <div className="relative container-sat grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="overline mb-6">{t("mentor.overline")}</div>
          <div className="rounded-2xl overflow-hidden glass">
            <img
              src="/brand/nenad-cosmic.jpg"
              alt={t("mentor.name")}
              className="w-full h-[560px] object-cover"
              data-testid="mentor-portrait"
            />
          </div>
          <div className="mt-6">
            <div className="serif text-3xl font-light">{t("mentor.name")}</div>
            <div className="text-sm tracking-widest uppercase text-white/45 mt-1">{t("mentor.role")}</div>
            <p className="serif italic text-lg text-white/70 mt-6 leading-snug">„{t("mentor.tagline")}"</p>
          </div>
        </div>

        <div className="lg:col-span-7 lg:pt-12">
          <div className="space-y-6 text-white/75 text-lg leading-relaxed">
            {story.map((p, i) => (
              <p key={i} className={i === 0 ? "dropcap serif text-2xl text-white/85" : ""} data-testid={`mentor-story-${i}`}>{p}</p>
            ))}
          </div>

          <div className="grid md:grid-cols-2 gap-8 mt-14">
            <div className="glass rounded-2xl p-8">
              <div className="overline mb-3">{t("mentor.mission_title")}</div>
              <p className="text-white/75 leading-relaxed">{t("mentor.mission")}</p>
            </div>
            <div className="glass rounded-2xl p-8">
              <div className="overline mb-3">{t("mentor.vision_title")}</div>
              <p className="text-white/75 leading-relaxed">{t("mentor.vision")}</p>
            </div>
          </div>

          <div className="mt-10">
            <div className="overline mb-4">{t("mentor.values_title")}</div>
            <ul className="space-y-3">
              {values.map((v, i) => (
                <li key={i} className="flex items-start gap-4 text-white/80">
                  <span className="serif text-[#D4AF37] mt-1">—</span>
                  <span className="text-lg">{v}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-12 border-t border-white/5 pt-8">
            <div className="serif italic text-3xl md:text-4xl text-[#D4AF37]">{t("mentor.motto")}</div>
            <p className="text-white/55 mt-3 max-w-xl">{t("mentor.motto_sub")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mentor;
